(() => {
 if(customElements.get('scent-vault-motion'))return;
 customElements.define('scent-vault-motion',class extends HTMLElement{
  connectedCallback(){this.generation=(this.generation||0)+1;const generation=this.generation;this.start(generation);}
  async start(generation){
   // The script can execute before the parser has reached this element's template.
   if(document.readyState==='loading')await new Promise(r=>document.addEventListener('DOMContentLoaded',r,{once:true}));
   if(!this.isConnected||generation!==this.generation)return;
   const root=this.shadowRoot||this.attachShadow({mode:'open'});root.innerHTML='<slot></slot>';
   try{
    const module=await import(this.dataset.module);
    if(!this.isConnected||generation!==this.generation)return;
    const css=document.createElement('link');css.rel='stylesheet';css.href=this.dataset.css;
    const styled=new Promise((resolve,reject)=>{css.onload=resolve;css.onerror=reject;});root.append(css);await styled;
    if(!this.isConnected||generation!==this.generation)return;
    root.querySelector('slot')?.remove();root.append(this.querySelector('template').content.cloneNode(true));
    const dispose=await module.mount(root,this);
    if(!this.isConnected||generation!==this.generation){dispose();return;}this.dispose=dispose;
   }catch(error){console.error('Scent Vault animation:',error);root.innerHTML='<slot></slot>';}
  }
  disconnectedCallback(){this.generation++;this.dispose?.();this.dispose=null;}
 });
})();
